import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
app.initializers.add('redundans/share-link', () => {
  // Vi utökar 'userControls' metoden i PostControls
  extend(PostControls, 'userControls', function (items, post) {
    // Generera den fullständiga permanenta länken till det specifika inlägget
    const postUrl = window.location.origin + app.route.post(post);
    items.add('copy-link', m(Button, {
      icon: "fas fa-link",
      onclick: () => {
        navigator.clipboard.writeText(postUrl).then(() => {
          // Visa en notifiering att kopieringen lyckades
          app.alerts.show({
            type: 'success'
          }, 'Länken kopierad till urklipp!');
        }).catch(err => {
          app.alerts.show({
            type: 'error'
          }, 'Kunde inte kopiera länk.');
          console.error('Kopiering misslyckades: ', err);
        });
      }
    }, "Kopiera l\xE4nk"), 10 // Prioritetsordning i dropdown-menyn
    );
  });
});